import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Alert, Card, CardBody } from "reactstrap";
import { useDispatch } from "react-redux";
import AirHomeLoader from "../../../components/Common/AirHomeLoader";
import Request from "../../../helpers/request";
import { RefreshBtn } from "../../../components/Common/button";

interface InterfaceDataTable {
  apiURL: string;
  title?: string;
  isReload?: boolean;
  columns: any[];
  selectedRoomID?: any[];
  loading: boolean;
  setLoading: (loading: boolean) => void;

  selectedTab: string | null;
}

function ListTable({
  apiURL,
  title,
  selectedRoomID,
  isReload,
  columns,
  loading,
  setLoading,
  selectedTab,
}: InterfaceDataTable) {
  const [data, setData] = useState<any[]>([]);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [error, setError] = useState<string>("");

  const fetchData = async (
    page: number,
    perPage: number,
    searchValue: string,
    selectedTab: string | null
  ) => {
    setLoading(true);
    try {
      const reqObj = {
        page: page,
        limit: perPage,
        isForERP: selectedTab === "erp" ? true : false,
        search: "",
        // ...(selectedPremise ? { premiseId: selectedPremise.id } : {}),
      };

      const response = await Request.post(apiURL, reqObj);

      // setData(response.data.data || []);
      setData(response.data.data.templates || []);

      setTotalRows(response.data.recordsTotal || 0);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 403) {
        setError(error?.response?.data?.msg || "You do not have access.");
      }
      if (error.response && error.response.status === 401) {
        // window.localStorage.clear();
        localStorage.removeItem("userInfo");
        localStorage.removeItem("selectedPremiseID");
        localStorage.removeItem("selectedUserID");
        localStorage.removeItem("selectedUserEmail");
        localStorage.removeItem("Authorization");
        localStorage.removeItem("permissions");
        window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, perPage, searchText, selectedTab);
  }, [
    page,
    perPage,
    searchText,
    apiURL,
    selectedRoomID,
    isReload,
    selectedTab,
  ]);

  const handlePageChange = (newPage: number) => setPage(newPage);

  const handlePerRowsChange = (newPerPage: number, newPage: number) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
    setPage(1);
  };

  const handleReload = () => {
    fetchData(page, perPage, searchText, selectedTab);
  };

  return (
    <Card
      style={{
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30,
        marginBottom: 0,
      }}
    >
      <CardBody>
        {error && <Alert color="danger">{error}</Alert>}

        <div className="">
          <DataTable
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            highlightOnHover
            customStyles={customStyles}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            subHeader
            subHeaderComponent={
              <div className="container-fluid p-0 pb-2">
                <div className="row gx-2 gy-2 align-items-center">
                  <div className="col-12 col-md-6 d-flex flex-wrap align-items-center gap-2">
                    <h5 className="m-0 fw-bold" style={{ fontSize: "18px" }}>
                      {title || "Data Table"}
                    </h5>
                  </div>

                  {/* Search and Action Buttons */}
                  <div className="col-12 col-md-6 d-flex flex-wrap justify-content-md-end align-items-center gap-2">
                    {/* Search Input */}
                    {/* <input
                      type="text"
                      placeholder="Search..."
                      className="form-control form-control-sm"
                      style={{ maxWidth: "150px" }}
                      value={searchText}
                      onChange={handleSearch}
                    /> */}

                    {/* <RefreshBtn onClick={handleReload} loading={loading} /> */}
                  </div>
                </div>
              </div>
            }
          />
        </div>
        {loading && <AirHomeLoader />}
      </CardBody>
    </Card>
  );
}

export default ListTable;

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};
